// /store/modules/lead.js
import apiClient from "../../plugins/axios";
import router from "../../router";

export default {
  namespaced: true,
  state: () => ({
    lead: null,
    loading: false,
    leadDialog: false,
    uploads: null,
    whatsAppMessages: [],
  }),
  mutations: {
    setLead(state, lead) {
      state.lead = lead;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setLeadDialog(state, leadDialog) {
      state.leadDialog = leadDialog;
    },
    setUploads(state, uploads) {
      state.uploads = uploads;
    },
    setWhatsAppMessages(state, messages) {
      state.whatsAppMessages = messages;
    },
    resetLead(state) {
      state.lead = null;
      state.uploads = null;
      state.whatsAppMessages = [];
    },
  },
  actions: {
    async fetchLeadData({ commit, dispatch }, leadId) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getLeadById?leadId=${leadId}`
        );
        commit("setLead", response.data);
        commit("setLeadDialog", true);
        dispatch("fetchUploads", leadId);
        dispatch("fetchWhatsAppMessages", leadId);
      } catch (error) {
        console.error("Failed to fetch lead data:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchUploads({ commit }, leadId) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getUploadsByLeadId?leadId=${leadId}`
        );
        const uploadsObject = response.data.reduce((obj, upload) => {
          obj[upload._id] = upload;
          return obj;
        }, {});
        commit("setUploads", uploadsObject);
      } catch (error) {
        console.error("Failed to fetch uploads:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchWhatsAppMessages({ commit }, leadId) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getWhatsAppMessagesByLead?leadId=${leadId}`
        );
        commit("setWhatsAppMessages", response.data);
      } catch (error) {
        console.error("Failed to fetch WhatsApp messages:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    setLeadDialog({ commit }, leadDialog) {
      commit("setLeadDialog", leadDialog);
    },
    closeLeadDialog({ commit, rootState }) {
      router.replace(rootState.agency.dialogReturnRoute);
      commit("resetLead");
      commit("setLeadDialog", false);
    },
    resetLead({ commit }) {
      commit("resetLead");
    },
  },
};

